import * as actionTypes from "./actionTypes";

export const fetchAuditLogsReport = (payload) => {
  return {
    type: actionTypes.FETCH_AUDIT_LOGS_REPORT,
    payload,
  };
};

export const fetchAuditLogsReportSuccess = (payload) => {
  return {
    type: actionTypes.FETCH_AUDIT_LOGS_REPORT_SUCCESS,
    payload,
  };
};

export const fetchAuditLogsReportFailed = (payload) => {
  return {
    type: actionTypes.FETCH_AUDIT_LOGS_REPORT_FAILED,
    payload,
  };
};

export const downloadAuditLogsReport = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_AUDIT_LOGS_REPORT,
    payload,
  };
};

export const downloadAuditLogsReportSuccess = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_AUDIT_LOGS_REPORT_SUCCESS,
    payload,
  };
};

export const downloadAuditLogsReportFailed = (payload) => {
  return {
    type: actionTypes.DOWNLOAD_AUDIT_LOGS_REPORT_FAILED,
    payload,
  };
};
